// extracted by mini-css-extract-plugin
export default {"root":"_1_wQ3","prefix":"u6o9a","avatar":"_2Z94w"};